import highlights from '@/mixins/search/highlights'

export default {
  mixins: [highlights],
  props: {
    highlights: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    highlightsLoading: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      claimPrefix: '<span class="t-500">Claim: </span>',
      abstractPrefix: '<span class="t-500">Abstract: </span>',
      fullTextPrefix: '<span class="t-500">Full text: </span>'
    }
  },
  computed: {
    patentNumber () {
      if (this.highlights && !this.isEmpty(this.highlights['patent_number.trimmed'])) {
        return this.highlights['patent_number.trimmed'][0]
      } else if (this.highlights && !this.isEmpty(this.highlights.patent_number)) {
        return this.highlights.patent_number[0]
      } else {
        return this.data.patent_number
      }
    },
    ipcCode () {
      if (this.highlights && !this.isEmpty(this.highlights['ipc_code.trimmed'])) {
        return this.highlights['ipc_code.trimmed'][0]
      } else if (this.highlights && !this.isEmpty(this.highlights.ipc_code)) {
        return this.highlights.ipc_code[0]
      } else {
        return this.data.ipc_code
      }
    },
    title () {
      return this.highlights && this.highlights.title ? this.highlights.title[0] : this.data.title
    },
    description () {
      if (!this.isEmpty(this.fullTextDescription) || !this.isEmpty(this.highlights.abstract) || !this.isEmpty(this.claimDescription)) {
        if (!this.isEmpty(this.highlights.abstract)) {
          return `${this.abstractPrefix} ${this.stripTagsNoMark(this.highlights.abstract)}`
        } else if (!this.isEmpty(this.fullTextDescription)) {
          return `${this.fullTextPrefix} ${this.stripTagsNoMark(this.fullTextDescription)}`
        } else {
          return `${this.claimPrefix} ${this.stripTagsNoMark(this.claimDescription)}`
        }
      } else {
        if (!this.isEmpty(this.data.abstract_short)) {
          return `${this.abstractPrefix} ${this.stripTagsNoMark(this.data.abstract_short)}`
        } else if (!this.isEmpty(this.data.full_text_short)) {
          return `${this.fullTextPrefix} ${this.stripTagsNoMark(this.data.full_text_short)}`
        } else if (!this.isEmpty(this.data.claim_short)) {
          return `${this.claimPrefix} ${this.stripTagsNoMark(this.data.claim_short)}`
        } else {
          return ''
        }
      }
    },
    inventors () {
      if (!this.isEmpty(this.data.parties)) {
        return this.data.parties.filter(p => p.role === 'inventor').sort((a, b) => a.order - b.order)
      }
      return []
    },
    assignees () {
      if (!this.isEmpty(this.data.parties)) {
        return this.data.parties.filter(p => p.role === 'assignee').sort((a, b) => a.order - b.order).map(p => {
          // Flatten organisation
          if (!p.organisation) {
            return {
              ...p,
              organisation_types: ['researcher'] // If no organisation, assume it's a researcher. Need this override to render icons
            }
          }
          return {
            ...p,
            ...p.organisation
          }
        })
      }
      return []
    },
    applicants () {
      if (!this.isEmpty(this.data.parties)) {
        return this.data.parties.filter(p => p.role === 'applicant').sort((a, b) => a.order - b.order).map(p => {
          // Flatten organisation
          if (!p.organisation) {
            return {
              ...p,
              organisation_types: ['researcher'] // If no organisation, assume it's a researcher. Need this override to render icons
            }
          }
          return {
            ...p,
            ...p.organisation
          }
        })
      }
      return []
    }
  },
  methods: {
    sortOrder (data) {
      return data.slice().sort((a, b) => a.order - b.order)
    }
  }
}
